module.exports = __webpack_public_path__ + "static/media/Q4_Front_Right.b99b3ffa.png";